import styled from "styled-components";

export const Wrapper = styled.div`
  width: 260px;
  height: 100vh;
  position: fixed;
  top: 4rem;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #e3ebcc;
  height: calc(100vh - 4rem);
  z-index: 40;
  border-right: 2px solid #d4ddb8;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
  
  @media screen and (max-width: 768px) {
    display: none;
  }

  button {
    border: none;
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  
  .logo {
    margin: 40px 0 24px 0;
  }

  .title {
    min-height: unset;
  }

  .active {
    padding: 14px 16px;
    background: linear-gradient(135deg, #4b975b 0%, #5dad6d 100%);
    border-left: 4px solid #3d7a49;
    box-shadow: 0 2px 8px rgba(75, 151, 91, 0.2);
  }
  
  .active p {
    color: #ffffff;
    font-weight: 600;
  }
  
  .active .box-contain {
    color: #ffffff;
  }
  
  .non-active {
    padding: 14px 16px;
    transition: all 0.2s ease-in-out;
    
    &:hover {
      background: #f5f5f5;
      padding-left: 20px;
    }
  }
  
  img {
    cursor: pointer;
  }
`;

export const SideContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease-in-out;
  
  p {
    color: #1f2c2b;
    font-weight: 500;
    font-size: 15px;
    margin: 0;
    margin-left: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    font-family: 'Plus Jakarta Sans', sans-serif;
  }
  
  .box-contain {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4b975b;
    border-radius: 8px;
    padding: 0;
    transition: all 0.2s ease-in-out;
    
    .icon {
      font-size: 18px;
    }
  }
  
  .dropdown-icon {
    margin-right: 12px;
    font-size: 14px;
    color: #6a7b76;
    transition: all 0.2s ease-in-out;
  }
  
  &.active .dropdown-icon {
    color: #ffffff;
  }
  
  &:hover .dropdown-icon {
    transform: translateX(2px);
  }
`;

export const DropdownContainer = styled.div`
  width: 100%;
  background: #f8faf9;
  border-left: 4px solid #4b975b;
  animation: slideDown 0.3s ease-in-out;
  
  @keyframes slideDown {
    from {
      opacity: 0;
      max-height: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      max-height: 300px;
      transform: translateY(0);
    }
  }
`;

export const DropdownItem = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 12px 16px 12px 32px;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.03);
  transition: all 0.2s ease-in-out;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #4b975b;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
  
  &:hover {
    background: rgba(75, 151, 91, 0.1);
    padding-left: 36px;
    
    &::before {
      opacity: 1;
    }
  }
  
  &.active {
    background: linear-gradient(135deg, #4b975b 0%, #5dad6d 100%);
    padding-left: 36px;
    
    &::before {
      background: #ffffff;
      opacity: 1;
    }
  }
  
  &.active p {
    color: #ffffff;
    font-weight: 600;
  }
  
  &.active .box-contain {
    color: #ffffff;
  }
  
  p {
    color: #1f2c2b;
    font-weight: 500;
    font-size: 14px;
    margin: 0;
    margin-left: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    font-family: 'Plus Jakarta Sans', sans-serif;
  }
  
  .box-contain {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4b975b;
    border-radius: 6px;
    padding: 0;
    transition: all 0.2s ease-in-out;
    
    .icon {
      font-size: 16px;
    }
  }
`;